import {
  message
} from 'antd';
import { AxiosError } from 'axios';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import CreateEmployeeFulltime from 'common/components/CreateEmployeeFulltime';
import { getStaffFulltimeByIdService } from 'common/services/extends/staffFulltime';

const EmployeeFulltimeDetail: React.FC<ActiveRoles> = (props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  /* States */
  const idParams = Number(searchParams.get('id'));

  /* Queries */
  const { data: staffAssignDetailRes, isLoading: detailLoading } = useQuery(
    ['get-staff-assign-detail', idParams],
    () => getStaffFulltimeByIdService(idParams),
    {
      enabled: !!idParams,
      onError: (error: unknown) => {
        if (error instanceof AxiosError) {
          message.error(
            error.response?.data?.message || t('message.anErrorHasOccurred')
          );
        }
      },
    }
  );

  return (
    <CreateEmployeeFulltime
      {...props}
      data={staffAssignDetailRes}
      loading={detailLoading}
    />
  );
};

export default EmployeeFulltimeDetail;
